import { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

import { TableContainer, Table, TableBody, TableRow, TableCell, Divider, Typography, Button } from '@mui/material';

import { NotificationModel } from 'model/notification/NotificationModels'

export class NotificationProps {
  notification: NotificationModel;
  onClose: any;
}

/* TODO: 
1. Next reminder needs to show the right date
4. Clear the day when changing to weekly
5. Add monthly limits, and add the warning
6. Update to use the month day in the status string
*/
export const Notification: FunctionComponent<NotificationProps> = ({ notification, onClose }) => {

  return (<>
    <Typography variant="h6" sx={{fontSize: "1rem !important"}}>{notification.title}</Typography>
    <Divider orientation="horizontal" flexItem sx={{mt: 2, mb:2, mr: -2, ml: -2}}/>
    <TableContainer style={{marginTop: "5px"}}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell align="right">{notification.status}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Recipient</TableCell>
            <TableCell align="right" style={{wordBreak:"break-word", whiteSpace: "normal"}}>{notification.recipient}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Sent Date</TableCell>
            <TableCell align="right">{dayjs(notification.sentDate).format('Do MMM YYYY')}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Amount</TableCell>
            <TableCell align="right">{`$${notification.amount.toLocaleString()}`}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Collection</TableCell>
            <TableCell align="right">
              <Link to={`/collection?id=${notification.collectionId}`}>
                <Typography variant="body1" style={{textDecoration:"underline"}}>
                  here
                </Typography>
              </Link>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
    <Button variant="contained" onClick={()=>onClose()} style={{position: "absolute", bottom: 0, marginTop: "15px", marginBottom: "15px"}}>Close</Button>
  </>
  )
}
export default Notification;